import { Box, CircularProgress, useTheme } from "@mui/material";

type CircularProgressCardVariant = "onDark" | "onLight";

interface CircularProgressWithLabelProps {
    // Completion percentage (0-100); values outside the range are clamped.
    value: number;
    size?: number;
    // Which card background the ring sits on. Picks the matching label + track colours as a pair.
    variant?: CircularProgressCardVariant;
}

const darkCardTrackColor = "#58649a";
const lightCardTrackColor = "rgba(0, 44, 117, 0.15)";

function CircularProgressWithLabel({ value, size = 60, variant = "onDark" }: CircularProgressWithLabelProps) {
    const theme = useTheme();
    const clampedValue = Math.min(100, Math.max(0, Math.round(value)));
    const labelColor = variant === "onLight" ? theme.palette.primary.dark : theme.customPalette.white;
    const trackColor = variant === "onLight" ? lightCardTrackColor : darkCardTrackColor;

    return (
        <Box sx={{ position: "relative", display: "inline-flex", width: size, height: size, flexShrink: 0 }}>
            <CircularProgress variant="determinate" value={100} size={size} sx={{ color: trackColor }} />
            <CircularProgress
                variant="determinate"
                value={clampedValue}
                size={size}
                sx={{ color: theme.palette.secondary.main, position: "absolute", left: 0 }}
            />
            <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Box sx={{ color: labelColor, fontSize: Math.round(size * 0.23) }}>{`${clampedValue} %`}</Box>
            </Box>
        </Box>
    );
}

export default CircularProgressWithLabel;
